/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import HeaderTabDropdown from './HeaderTabDropdown';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';

class HeaderTablet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ProductsDownArrow: true,
    };
  }

  render() {
    const menu = this.props.data.menu.items;
    return (
    // <!-- Product dropdown tablet starts -->
      <div id="mysidenav" className={`product-dropdown-tablet ${this.props.active ? "sidenav" : "sidenav-visible"}`}>
        <div className="container">
          <div className="row justify-content-center button-sidenav">
            <div className="col">
              <div className="login-btn-tablet">
                {(Cookies.get('user-oauth-token', {domain: '.efficientlearning.com'}) ||
                Cookies.get('user-logged-in', {domain: '.efficientlearning.com'}))?
                <a href={global.accountUrl}>
                  <button type="button" className="nav-login-btn">Account</button>
                </a>:
                <a href={global.loginUrl}>
                  <button type="button" className="nav-login-btn">Log in</button>
                </a>}
              </div>
            </div>
            <div className="col call-us-tablet">
              <div className="login-btn-tablet">
                <a href={global.callUsUrl}>
                  <button type="button" className="nav-call-us-btn">Call Us</button>
                </a>
              </div>
            </div>
          </div>
        </div>
        {menu.map((item) => (
          <React.Fragment key={item.title}>
            { item.title === 'Products'
              ? (
                (this.props.showProductLink === "/" || !this.props.pathContains)
                && (
                <>
                  <a
                    role="button"
                    className="products-collapse collapsed-navbar-bkg"
                    data-toggle="collapse"
                    data-target="#productsCollapse"
                    aria-expanded="true"
                    aria-controls="productsCollapse"
                    onClick={() => this.setState((prevState) => (
                      { ProductsDownArrow: !prevState.ProductsDownArrow }))}
                  >
                    {item.title}
                    <span className={`arrow ${this.state.ProductsDownArrow ? 'fa fa-chevron-up'
                      : 'fa fa-chevron-down'}`}
                    />
                  </a>
                  <HeaderTabDropdown data={item} />
                </>
                )
              )
              : (
                <>
                  {/* style={{ marginBottom: "3%" }} */}
                  {(item.url.indexOf('http://') === 0 || item.url.indexOf('https://') === 0)?
                  <a className={`collapsed-navbar-bkg hi ${item.title === 'Contact' ? "nav-bottom" : ''}`} href={item.url}>{item.title}</a>
                  :<Link className={`collapsed-navbar-bkg ${item.title === 'Contact' ? "nav-bottom" : ''}`} to={item.url}>{item.title}</Link>}
                </>
              )}
          </React.Fragment>
        ))}
      </div>
    );
    // <!-- Product dropdown tablet ends -->
  }
}

export default HeaderTablet;
